
import actions from './actions'
import mutations from './mutations'

let state = {
    all: null,
    count: 0,
    page: 1
}

const ACTIONS = {
    GET_ALL: 'devis/getAll',
    GET_NEXT: 'devis/getNext'
}

export default {
    namespaced: true,
    state,
    actions,
    mutations
}

export { ACTIONS as actions }